import React, { useEffect, useRef } from "react";
import Button from "../../Utilities/Button";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { useNavigate } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);
const Cta = () => {
  const blockRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    gsap.fromTo(
      blockRef.current,
      { y: 0 },
      {
        y: -100,
        delay: 1,
        duration: 1,
        scrollTrigger: {
          trigger: blockRef.current,
        },
      }
    );
  }, []);
  return (
    <div className="layout text-N90 my-24 mt-40" ref={blockRef}>
      <div className="bg-N5/30 w-11/12 md:w-full xl:w-4/5 2xl:w-3/4 mx-auto p-8 flex flex-col md:flex-row gap-6 justify-between items-center rounded-md shadow-md">
        <div className="flex flex-col gap-2 text-center md:text-left md:max-w-2xl">
          <h1 className="text-2xl 2xl:text-3xl font-semibold">
            Looking for a frontend engineer who builds fast, polished web apps?
          </h1>
          <p className="text-N60 lg:text-lg">
            Open to remote roles and freelance work — React, Next.js, AI integrations, and complex dashboards.
          </p>
        </div>
        <Button
          variant="primary"
          onClick={() => navigate("/contact")}
          custom="w-max py-2"
        >
          contact me
        </Button>
      </div>
    </div>
  );
};

export default Cta;
